import { render, staticRenderFns } from "./TwoFactorsAuth.vue?vue&type=template&id=2cb0553b&scoped=true"
import script from "./TwoFactorsAuth.vue?vue&type=script&lang=js"
export * from "./TwoFactorsAuth.vue?vue&type=script&lang=js"
import style0 from "./TwoFactorsAuth.vue?vue&type=style&index=0&id=2cb0553b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb0553b",
  null
  
)

export default component.exports